import React, { useState, useRef, createRef } from "react";
import styled from "styled-components";
import { Box } from "@mui/material";
import { useOnClickOutside } from "../../../../utils/utilFunctions";
import TooltipIconButton from "components/TooltipIconButton";
import { FiberManualRecord, DeleteOutline } from "@mui/icons-material";
import ColorButton from "components/common/ColorButton";
import { splitArrayIntoChunksOfLen } from "helper";
import { Colors } from "constant";

const TypeItem = styled.div`
  svg {
    fill: ${props => props.color ? props.color + " !important" : ""};
  }
  
  svg.delete-icon {
    fill: #A0A0A0 !important;
  }

  .MuiIconButton-root:hover {
    svg.delete-icon {
      fill: #e5e5e5 !important;
    }
  }
`;

const ProjectTypeRow = ({
  type,
  selectedType,
  handleTypeClick,
  removeProjectType,
  handleShowColorPicker,
  hanldeProjectColor
}) => {
  const ref = useRef();
  const exceptional = createRef();
  const [showProjectColorPicker, setShowProjectColorPicker] = useState(false);

  useOnClickOutside(ref, () => setShowProjectColorPicker(false), exceptional);

  const ShowColorPicker = (e, type) => {
    setShowProjectColorPicker(true);
    handleShowColorPicker(e, type);
  }

  const UpdateProjectColor = (color) => {
    setShowProjectColorPicker(false);
    hanldeProjectColor(color);
  }

  return (
    <>
      <TypeItem
        className={`type-item ${type.pk === selectedType.pk && 'selected'}`}
        onClick={() => handleTypeClick(type)}
        id={type.pk}
        key={type.pk}
        color={type.fields.COLOR}
      >
        <span>{type.fields.TYPENAME}</span>
        <div className="action-groups">
          {
            type.fields.TYPENAME !== "Uncategorized" &&
            <TooltipIconButton title="Remove" ariaLabel="remove" placement="left" size={34} onClick={(e) => removeProjectType(e, type.pk)}>
              <DeleteOutline className="delete-icon" />
            </TooltipIconButton>
          }
          <TooltipIconButton title="Color" ariaLabel="color" placement="right" size={34} onClick={(e) => ShowColorPicker(e, type)} ref={exceptional}>
            <FiberManualRecord />
          </TooltipIconButton>
        </div>
      </TypeItem>
      {showProjectColorPicker &&
        <div className="color-pallete" ref={ref}>
          {splitArrayIntoChunksOfLen(Colors, 8).map((itemList, index) => (
            <Box display="flex" flexDirection="row" my="9px" key={index}>
              {itemList.map((item, itemIndex) => (
                <Box mx="6px" key={itemIndex}>
                  <ColorButton
                    color={item}
                    active={type.fields.COLOR === item}
                    onClick={() => UpdateProjectColor(item)}
                  />
                </Box>
              ))}
            </Box>
          ))}
        </div>
      }
    </>
  );
};

export default ProjectTypeRow;
